import type { FromModel } from "@/__main__/data-model.mjs";
import createModel from "@/__main__/data-model.mjs";
import { userModel } from "@/feature-auth/models/user-model.mjs";

export const userRolesModel = userModel.roles;

export type UserRoles = FromModel<typeof userModel>;

const UserRolesModel = createModel({
  data: {
    me: {
      roles: userModel.roles,
    },
  },
}).transform(userModel.roles, (data) => data.data.me.roles);

export default UserRolesModel;
